/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { AdminDataWorkAgencyGrantIdDTO } from './AdminDataWorkAgencyGrantIdDTO';
import {
    AdminDataWorkAgencyGrantIdDTOFromJSON,
    AdminDataWorkAgencyGrantIdDTOFromJSONTyped,
    AdminDataWorkAgencyGrantIdDTOToJSON,
    AdminDataWorkAgencyGrantIdDTOToJSONTyped,
} from './AdminDataWorkAgencyGrantIdDTO';

/**
 * 
 * @export
 * @interface AdminDataWorkGrantAgencyDTO
 */
export interface AdminDataWorkGrantAgencyDTO  {
    /**
     * 
     * @type {number}
     * @memberof AdminDataWorkGrantAgencyDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminDataWorkGrantAgencyDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminDataWorkGrantAgencyDTO
     */
    acronym?: string;
    /**
     * 
     * @type {Array<AdminDataWorkAgencyGrantIdDTO>}
     * @memberof AdminDataWorkGrantAgencyDTO
     */
    grantIds?: Array<AdminDataWorkAgencyGrantIdDTO>;
}

/**
 * Check if a given object implements the AdminDataWorkGrantAgencyDTO interface.
 */
export function instanceOfAdminDataWorkGrantAgencyDTO(value: object): value is AdminDataWorkGrantAgencyDTO {
    return true;
}

export function AdminDataWorkGrantAgencyDTOFromJSON(json: any): AdminDataWorkGrantAgencyDTO {
    return AdminDataWorkGrantAgencyDTOFromJSONTyped(json, false);
}

export function AdminDataWorkGrantAgencyDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminDataWorkGrantAgencyDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'name': json['name'] == null ? undefined : json['name'],
                  'acronym': json['acronym'] == null ? undefined : json['acronym'],
              'grantIds': json['grantIds'] == null ? undefined : ((json['grantIds'] as Array<any>).map(AdminDataWorkAgencyGrantIdDTOFromJSON)),
    };
}

export function AdminDataWorkGrantAgencyDTOToJSON(json: any): AdminDataWorkGrantAgencyDTO {
    return AdminDataWorkGrantAgencyDTOToJSONTyped(json, false);
}

export function AdminDataWorkGrantAgencyDTOToJSONTyped(value?: AdminDataWorkGrantAgencyDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'acronym': value['acronym'],
        'grantIds': value['grantIds'] == null? value['grantIds']: (value['grantIds'] as Array<any>).map(AdminDataWorkAgencyGrantIdDTOToJSON),
    };
}


